import { initializeApp } from 'firebase/app'
import 'firebase/firestore'
const app = initializeApp(
  {
    apiKey: 'AIzaSyCKMgE00vEqNRtGOpr_NHShnftlAppFVZQ',
    authDomain: 'hypertech-ltd.firebaseapp.com',
    databaseURL: 'https://hypertech-ltd.firebaseio.com',
    projectId: 'hypertech-ltd',
    storageBucket: 'hypertech-ltd.appspot.com',
    messagingSenderId: '1005863743538'
  }
)

export const db = app.firestore()
export const contactsCollection = db.collection('contacts')
export const postsCollection = db.collection('posts')
